import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MetricsService } from '@jeppesen-foreflight/jmkw-analytics';
import { BasicButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { TwcPluginService } from './plugins/twc.plugin.service';
import {
  TwcPluginEnvironment,
  TWC_CONFIG_TOKEN
} from './plugins/twc-config.token';
import { TwcLegendComponent } from './twc-legend/twc-legend.component';

@NgModule({
  imports: [
    TwcLegendComponent,
    BasicButtonComponent,
    CommonModule
  ],
  providers: [TwcPluginService, MetricsService]
})
export class TwcPluginModule {
  static forRoot(
    twcEnvironmentConfig: Partial<TwcPluginEnvironment>
  ): ModuleWithProviders<TwcPluginModule> {
    return {
      ngModule: TwcPluginModule,
      providers: [
        {
          provide: TWC_CONFIG_TOKEN,
          useValue: twcEnvironmentConfig
        }
      ]
    };
  }
}
